import React from 'react';
import { LoginWidget } from './widget';

export const LoginPage: React.FC = () => <LoginWidget />;
